export default __webpack_public_path__ + "static/media/experienceClassplus.b3d64dc8.png";